import React from 'react';
import useEducators from './useEducators';

export default function useInactiveEducators(state, network, schoolStart, schoolEnd, currentTimestamp) {
  return useEducators(state, network, schoolStart, schoolEnd, {
    inactive: true
  });
}
